module.exports = __webpack_public_path__ + "media/images/icon_list/add_indent-a6eaacb742d380265aaaa66b6487b7b4.svg";